<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app">
        <app-drawer class="app--drawer"></app-drawer>
        <app-toolbar class="app--toolbar"></app-toolbar>
        <v-content>
          <!-- Progress Bar -->
          <v-progress-linear :indeterminate="true" v-show="isLoading"
            style="z-index:9999;position: fixed"></v-progress-linear>
          <!-- Page Header -->
          <page-header v-if="$route.meta.breadcrumb"></page-header>
          <div class="page-wrapper">
            <router-view></router-view>
          </div>
          <!-- App Footer -->
          <v-footer height="auto" class="white pa-3 app--footer">
            <span class="caption">{{ /*new Date().getFullYear()*/ }}</span>
            <v-spacer></v-spacer>
          </v-footer>
        </v-content>
        <!-- Go to top -->
        <app-fab></app-fab>
        <!-- theme setting -->
        <v-btn small fab dark falt fixed top="top" right="right" class="setting-fab" color="red"
          @click="openThemeSettings">
          <v-icon>settings</v-icon>
        </v-btn>
        <v-navigation-drawer class="setting-drawer" temporary right v-model="rightDrawer" hide-overlay fixed>
          <theme-settings></theme-settings>
        </v-navigation-drawer>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-snackbar :timeout="snackbar.timeout" auto-height :multi-line="snackbar.mode === 'multi-line'" bottom
      snackbar.position :color="snackbar.color" v-model="snackbar.show" :class="snackbar.class">
      <v-icon class="pr-3" dark>{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import AppDrawer from '@/components/AppDrawer';
import AppToolbar from '@/components/AppToolbar';
import AppFab from '@/components/AppFab';
import PageHeader from '@/components/PageHeader';
import menu from '@/api/menu';
import ThemeSettings from '@/components/ThemeSettings';
import AppEvents from './event';
import DatetimePicker from 'vuetify-datetime-picker'
import 'vuetify-datetime-picker/src/stylus/main.styl'
import Vue from 'vue'

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
    ThemeSettings
  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: '',
      color: '',
    }
  }),

  computed: {
    isLoading() {
      return this.$store.getters['loading/isLoading'];
    },
    isAuth() {
      return this.$store.getters['auth/isAuth'];
    },
    isSessionValid() {
      return this.$store.dispatch('auth/isValidApiKey');
    }
  },

  created() {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });

    console.debug('Options: ', this.$store.state);

    window.getApp = this;

    Vue.use(DatetimePicker);

    // Запрет перехода на страницу при вбивании адреса напрямую в браузере
    if (!this.isAuth) {
      window.getApp.$emit('APP_ACCESS_DENIED');
    }
  },

  beforeMount() {
  },

  // mounted () {
  //         setInterval(() => {
  //           this.$store._actions['logServer/getSomeLogs'][0]();
  //         }, 10000);

  //     },

  methods: {
    openThemeSettings() {
      this.$vuetify.goTo(0);
      this.rightDrawer = (!this.rightDrawer);
    },
  },

};
</script>


<style lang="stylus">
  .setting-fab 
    top:50%!important; 
    right:0;
    border-radius:0  
  .page-wrapper
    min-height:calc(100vh - 64px - 50px - 81px );  

    .v-toolbar {
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
    }
  </style>
<style>
.layout.login-inner.align-center.justify-center.d-flex.flex-column.ga-8 {
  max-height: 75%;
}

.login-otp-form-outer.v-card {
  flex-direction: column;
}

.codeDisabled {
  pointer-events: none;
  opacity: .5;
  filter: grayscale(1);
}

.authDisabled {
  opacity: .5;
  pointer-events: none;
}

.otp-code-reset-inline-button {
  cursor: pointer;
}

.otp-code-reset-inline-button:hover {
  color: black;
}

.triangle {
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 0 25px 15px 25px;
  border-color: transparent transparent #FFFFFF transparent;
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  margin: 0 auto;
}

.flex.login-form-outer {
  /*box-shadow: 0px 50px 75px #0c105391;
  z-index: 99;*/
}

.otp-code-retry-inline-button {
  cursor: pointer;
}

.login-otp-form-outer.v-card.v-sheet div,
.login-otp-form-outer.v-card.v-sheet input,
.login-otp-form-outer.v-card.v-sheet span {
  transition: .25s all ease-in-out !important;
}

.otp-code-retry-count {
  border: 1px solid #ffffff17;
}

.singular-code {
  transition: .25s all ease-in-out !important;
}

.otp-code-retry-inline-button:hover {
  filter: brightness(1.2);
}

.otp-login-detail {
  text-decoration: underline dotted;
}

#login {
  background: url("data:image/svg+xml,%3Csvg width='502' height='117' viewBox='0 0 502 117' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M489 26C496.18 26 502 20.1797 502 13C502 5.8203 496.18 0 489 0C481.82 0 476 5.8203 476 13C476 20.1797 481.82 26 489 26ZM34.2131 87.7991L28.1037 116H0L19.2788 26H62.9956C73.5854 26 81.5956 28.8336 86.3474 34.3658C90.5562 39.0885 93 46.2399 93 53.5262C93 62.8366 88.927 72.5517 82.2745 79.1634C76.4365 84.9655 68.1547 87.7991 57.2934 87.7991H34.2131ZM38.8292 65.8051H52.6774C56.7504 65.8051 58.9226 64.9955 61.2307 62.8366C63.2672 60.8126 64.4891 57.979 64.4891 55.1454C64.4891 50.018 61.638 47.5892 55.6642 47.5892H42.7664L38.8292 65.8051ZM216.213 87.7991L210.104 116H182L188.899 83.792H180.5L173.548 116.176H155.884H150L151 112.5C151 112.5 146.796 116.176 138 116.176H132.332C123.5 116.176 114.668 112.848 108.652 107.216C101.612 100.56 97.132 89.424 97.132 78.544C97.132 64.208 103.404 48.848 113.516 38.864C121.964 30.416 133.228 26.448 148.204 26.448C157.932 26.448 164.972 28.112 170.86 31.696C179.052 36.688 183.66 44.88 183.66 54.736V54.7361C183.66 55.1202 183.66 56.0161 183.532 57.04H158.828C158.06 50.384 153.836 46.928 146.412 46.928C134.38 46.928 123.756 61.904 123.756 78.672C123.756 88.4 129.772 94.544 139.116 94.544C146.156 94.544 152.3 90.32 154.86 83.792H143.084L146.796 66.128H183.788H192.683L201.279 26H244.996C255.585 26 263.596 28.8336 268.347 34.3658C272.556 39.0885 275 46.2399 275 53.5262C275 62.8366 270.927 72.5517 264.274 79.1634C258.436 84.9655 250.155 87.7991 239.293 87.7991H216.213ZM220.829 65.8051H234.677C238.75 65.8051 240.923 64.9955 243.231 62.8366C245.267 60.8126 246.489 57.979 246.489 55.1454C246.489 50.018 243.638 47.5892 237.664 47.5892H224.766L220.829 65.8051ZM353.832 33.5749C347.135 28.6961 338.376 26 328.974 26C315.321 26 303.987 30.4936 294.327 39.7375C284.667 49.1098 279 62.9757 279 77.2268C279 89.9372 283.508 100.337 291.88 107.013C299.093 112.79 309.01 116 319.572 116C347.006 116 368 93.9173 368 65.1583C368 51.164 363.234 40.3795 353.832 33.5749ZM314.291 53.6034C318.155 48.9815 322.92 46.5421 328.201 46.5421C336.315 46.5421 341.725 52.9615 341.725 62.4622C341.725 79.4094 331.292 94.3024 319.443 94.3024C311.329 94.3024 305.533 87.7546 305.533 78.3823C305.533 69.5235 308.881 60.2796 314.291 53.6034ZM401.465 79.9071H427.562L419.934 115H447.771L452.522 92.75L455.612 79.9071L470.772 79.907L476 55.4888H460.317L462.024 48.25L466.775 26H438.938L432.782 55.4888H406.685L412.975 26H385.004L380.253 48.25L370.751 92.75L366 115H393.971L401.465 79.9071Z' fill='white' fill-opacity='0.1'/%3E%3C/svg%3E%0A"), #0c1053 !important;
  background-position-x: 0%, 0%;
  background-position-y: 0%, 0%;
  background-repeat: repeat, repeat;
  background-size: auto, auto;
  background-size: 120% !important;
  background-repeat: no-repeat !important;
  background-position-y: 125% !important;
  background-position-x: 20% !important;
}

.otp-code-retry-count {
  color: white;
  padding: 6px;
  border-radius: 6px;
  background: #ffffff0f;
}

.admin-heading {
  padding: 6px;
  padding-top: 6px;
  padding-bottom: 6px;
  background: #8080801c;
  border-radius: 6px;
  padding-bottom: 3px;
  padding-top: 3px;
  margin-top: 3px;
  color: gray;
  font-size: .85em;
}

.login-otp-form-outer.v-card.v-sheet.theme--light[data-v-a60344ca] {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  gap: .5em;
  flex-direction: column;
}

.otp-code-retry-inline-button {
  background: #3f51b5;
  padding: 6px;
  border-radius: 6px;
  margin-right: 6px;
  margin-top: 12px;
  color: white;
}

.login-otp-form-outer {
  gap: 1.4em !important;
}

.otp-code-form-inner {
  display: flex;
  gap: 0.5em;
}

.login-otp-form-outer {
  justify-content: space-between;
}

.singular-code {
  max-width: 50px !important;
  height: 75px !important;
  font-size: 3em;
  width: 100%;
}

.singular-code {
  border-radius: 6px !important;
}

.login-otp-form-outer.v-card {
  padding: 24px 24px !important;
  border-radius: 6px;
}

.singular-code {
  border-radius: 6px !important;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3f51b5;
}

.login-otp-form-outer {
  display: flex;
  justify-content: start;
}

.singular-code {
  border: 1px solid #80808038;
  border-radius: 6px;
  height: 100%;
  max-width: 15%;
  min-height: 50px;
  background: #8080800f;
}

.layout.login-inner.align-center.justify-center.d-flex.flex-column.ga-8 {
  display: flex;
  flex-direction: column;
  gap: 2em;
}

#login {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}

.login-button {
  min-height: 50px;
  border-radius: 6px;
  font-size: 1.21em;
}

.login-form-wrapper {
  border-radius: 6px;
}

.flex.login-otp-form-outer.pa-3 {
  height: max-content;
  display: flex;
  align-items: center;
}

.flex.login-form-outer {
  width: 100%;
}

.flex.login-otp-form-wrapper {
  width: 100%;
}

.layout.login-inner {
  max-width: 20%;
  margin: 0 auto;
}

.otp-code-reset-auth {
  color: gray;
}

.otp-failure[data-v-a60344ca] {
  border: 1px solid #ff3f5a2e !important;
  -webkit-box-shadow: 0px 0px 12px #ff004833 !important;
  box-shadow: 0px 0px 12px #ff004833 !important;
  background: #ff2c402e !important;
  color: #c15050 !important;
}

.otp-success {
  border: 1px solid #ccff3f17 !important;
  box-shadow: 0px 0px 12px #dfff001a !important;
  background: #b3ff2c1a !important;
  color: #728611 !important;
}

@media (min-width: 1440px) and (max-width: 1750px) {
  .layout.login-inner {
    max-width: 30%;
    margin: 0 auto;
  }
}

@media (min-width: 1100px) and (max-width: 1440px) {
  .layout.login-inner {
    max-width: 40%;
    margin: 0 auto;
  }
}

@media (min-width: 700px) and (max-width: 1100px) {
  .layout.login-inner {
    max-width: 50%;
    margin: 0 auto;
  }
}

@media (max-width: 700px) {
  .layout.login-inner {
    max-width: 85%;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue